import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MicIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3C10.3431 3 9 4.34315 9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 4.34315 13.6569 3 12 3ZM11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V6Z"
      fill="currentColor"
    />
    <path
      d="M6 11C6.55228 11 7 11.4477 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 11.4477 17.4477 11 18 11C18.5523 11 19 11.4477 19 12C19 15.5265 16.3923 18.4439 13 18.9291V20H15C15.5523 20 16 20.4477 16 21C16 21.5523 15.5523 22 15 22H9C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20H11V18.9291C7.60771 18.4439 5 15.5265 5 12C5 11.4477 5.44772 11 6 11Z"
      fill="currentColor"
    />
  </svg>
);

MicIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MicIcon);
